import React from 'react';
import FormGrid from 'components/FormGrid';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAction } from 'reducer/common/login';
import Button from 'tradevan-ui/Button';
import Grid from 'tradevan-ui/Grid';
import Input from 'tradevan-ui/Input';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { APP_PATH } from 'config';
import StatusEnum from 'axios/enum';
import { localStorageRetaierIdName, showResponseSnackBar } from 'consts';
import ReactSelect from 'components/ReactSelect';
import { EnumLayoutRouter } from 'router/enum';

enum EnumMaster {
  userId = 'userId',
  securePwd = 'securePwd',
  rememberAccount = 'rememberAccount',
}
interface Imaster {
  [EnumMaster.userId]: string;
  [EnumMaster.securePwd]: string;
  // [EnumMaster.rememberAccount]: boolean;
}

interface InputForm {
  master: Imaster;
}

const Login = () => {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { setLoginRedux } = loginAction;

  const { register, handleSubmit, getValues, watch, control } =
    useForm<InputForm>({
      defaultValues: {
        master: {
          userId: '',
          securePwd: '',
          // rememberAccount: true,
        },
      },
    });
  watch('master');
  const { master } = getValues();
  /** 登入 */
  const handleLogin = async () => {
    localStorage.removeItem(localStorageRetaierIdName);
    const response = await axios.doAxios(
      MethodEnum.post,
      '/token/login',
      master,
    );
    if (response) {
      showResponseSnackBar(response.data);
      if (response.data.status === StatusEnum.完成) {
        dispatch(setLoginRedux(true));
        navigate(APP_PATH + EnumLayoutRouter.訂單下載);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(handleLogin)}>
      <Grid container>
        <FormGrid title="帳號">
          <ReactSelect
            name="master.userId"
            value={master[EnumMaster.userId]}
            control={control}
            watchValue={() => watch('master.userId')}
            options={[
              { value: 'LGC353M', label: 'LGC353M' },
              { value: 'LGC354M', label: 'LGC354M' },
              { value: 'LGC14277M', label: 'LGC14277M' },
              { value: 'LGC14278M', label: 'LGC14278M' },
            ]}
          />
        </FormGrid>
        <FormGrid title="帳號">
          <Input {...register('master.userId')} type="text" />
        </FormGrid>
        <FormGrid title="密碼">
          <Input {...register('master.securePwd')} type="password" />
        </FormGrid>
        <FormGrid title="">
          <div>V20260605</div>
        </FormGrid>
        <FormGrid title="">
          <Button type="submit">登入</Button>
        </FormGrid>
      </Grid>
    </form>
  );
};
export default Login;
